exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".LinkBar__links--1f4839 {\n  width: 100%;\n  color: #808080;\n  font-size: 14px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  text-align: center;\n\n  padding-bottom: 24px;\n}\n\n.LinkBar__link--20d6d1 {\n  cursor: pointer;\n  margin-left: 15px;\n  margin-right: 15px;\n  padding-bottom: 5px;\n  white-space: nowrap;\n}\n\n.LinkBar__active--52def0 {\n  color: black;\n  border-bottom: solid 2px;\n}\n", ""]);

// exports
exports.locals = {
	"links": "LinkBar__links--1f4839",
	"link": "LinkBar__link--20d6d1",
	"active": "LinkBar__active--52def0 LinkBar__link--20d6d1"
};


//////////////////
// WEBPACK FOOTER
// /tw-build/dev/global-site/~/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:6]"}!/tw-build/dev/global-site/~/postcss-loader!./component/LinkBar/LinkBar.css
// module id = 108
// module chunks = 0